import { apiModule } from '@/helpers/utils';
import axios from 'axios';
const administrationModule = apiModule.ADMINISTRATION;

export default {
  getApplyTypes: () => axios.get(`app/complaints/api/Lookups/GetApplyTypes`),
  getCountries: () => axios.get(`${administrationModule}/countries`),
  getCitiesByRegion: regionId =>
    axios.get(`${administrationModule}/cities`, getQueryParamsWithFilters([{
      field: 'isActive',
      value: 1,
    }, {
      field: 'regionId',
      value: regionId,
    }])),
  getDistrictsByCity: cityId =>
    axios.get(`${administrationModule}/districts`, getQueryParamWithOneFilter('cityId', cityId)),
  getDepartmentsByCourtIds: courtIds => axios.post(`${administrationModule}/departments-by-courtIds`, getQueryFiltersForPost([{
    field: 'courtIds',
    value: courtIds,
  }])),
};

const getQueryParamWithOneFilter = (field, value) => ({
  params: {
    query: {
      filters: [{
        field,
        value,
      }],
    },
  },
});

const getQueryParamsWithFilters = filters => ({ params: { query: { filters: filters } } });
const getQueryFiltersForPost = filters => ({ filters: filters });
